import React, {useState, useCallback, useRef, useEffect} from 'react';
import {AgGridReact} from 'ag-grid-react';
import {useSelector} from "react-redux";
import {PAGINATION_PAGE_SIZE_ARR} from "../../../constants";
import CustomSelect from "../../CustomSelect";

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import './table.scss';

const Table = ({
                    rowData,
                    defaultColDef,
                    columnDefs,
                    onGridReady,
                    onFilterChanged,
                    onSortChanged,
                    headerClassCol = false,
                    smallTable = false,
                    getTableRef,
                    filterStatus = false,
                    removeActiveFilter,
                    rowSelection,
                    onSelectionChanged,
                    totalRows,
                    currentPage,
                    perPage = 10,
                    onPageChange,
                    onPerPageChange,
               }) => {
    const tableRef = useRef(null);
    const menuStatus = useSelector(state => state.dataUploader.collapseMenu);
    const [tagsArr, setTagsArr] = useState([]);
    const [activeTagsArr, setActiveTags] = useState([]);

    const totalPages = Math.ceil(totalRows / perPage);
    const rowFrom = totalRows === 0 ? 0 : (currentPage - 1) * perPage + 1;
    const rowTo = Math.min(currentPage * perPage, totalRows);


    useEffect(() => {
        if (!smallTable && getTableRef) getTableRef(tableRef.current);
    }, [tableRef])

    useEffect(() => {
        if(filterStatus) {
            setActiveTags(['offer_status']);
        }
    }, [filterStatus])

    const cellClickedListener = useCallback(e => {
        navigator.clipboard.writeText(e.value);
    }, []);

    const addFilterTags = params => {
        let arr = [];
        let uniqueArray;
        const colArr = params.columnApi.columnModel.gridColumns;
        colArr.forEach(el => {
            if (el.filterActive) {
                arr.push(el.colId);
            }
        })
        uniqueArray = [...new Set(arr)];
        setTagsArr(uniqueArray);
    }

    const removeFilter = e => {
        const filterInstance = tableRef.current.api.getFilterInstance(e.target.id);
        filterInstance.setModel(null);
        tableRef.current.api.onFilterChanged();
    }

    const filterEvent = params => {
        addFilterTags(params);
        return onFilterChanged ? onFilterChanged(params) : null;
    }

    const paginationNumberFormatter = useCallback(params => {
        return params.value.toLocaleString();
    }, []);

    const onPageSizeChanged = useCallback(value => {
        if (tableRef.current.api && !isNaN(Number(value))) tableRef.current.api.paginationSetPageSize(Number(value));
    }, []);

    return (
        <div className={`ag-theme-alpine${smallTable ? ' small-table' : ''}${headerClassCol ? ' col-names-break' : filterStatus && activeTagsArr.length > 0 ? ' shorter-table-wrap-with-tag' : ''}`}
             style={smallTable ? {
                 width: `${!menuStatus ? 'calc(100vw - 9.5rem)' : 'calc(100vw - 21rem)'}`,
                 marginTop: "3rem"
             } : {
                 width: `${!menuStatus ? 'calc(100vw - 9.5rem)' : 'calc(100vw - 21rem)'}`,
                 maxHeight: "calc(100vh - 15.2rem)",
                 "transition": 'width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms'
             }}>

            <div className="filter-tags-block">
                {filterStatus && activeTagsArr.length > 0 ?
                    <ul className='filter-tags-container filter-tags-active-container'>
                        {activeTagsArr.map((tag, i) => {
                            return (
                                <li key={i} className='filter-tags-active'>
                                    {tag}
                                    <button id={tag} onClick={removeActiveFilter}>
                                        <img id={tag} src={`${process.env.PUBLIC_URL}/images/close-icon.svg`} alt="close"/>
                                    </button>
                                </li>
                            )
                        })}
                    </ul>
                    : null
                }

                {tagsArr.length > 0 ?
                    <ul className='filter-tags-container'>
                        {tagsArr.map((tag, i) => {
                            return (
                                <li key={i}>
                                    {tag}
                                    <button id={tag} onClick={removeFilter}>
                                        <img id={tag} src={`${process.env.PUBLIC_URL}/images/close-icon.svg`} alt="close"/>
                                    </button>
                                </li>
                            )
                        })}
                    </ul>
                    : null
                }
            </div>

            <>
                <div className='table-inner-container'>
                    <AgGridReact
                        ref={tableRef}
                        rowData={rowData}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        onCellClicked={cellClickedListener}
                        onGridReady={onGridReady}
                        onFilterChanged={params => filterEvent(params)}
                        onSortChanged={onSortChanged ? params => onSortChanged(params) : null}
                        tooltipShowDelay={1000}
                        tooltipHideDelay={1000}
                        paginationPageSize={10}
                        paginationTotalRows={totalRows}
                        paginationNumberFormatter={paginationNumberFormatter}
                        animateRows={true}
                        pagination={false} 
                        enableFilter={true}
                        enableSorting={true}
                        rowSelection={rowSelection ? rowSelection : false}
                        rowMultiSelectWithClick={!!rowSelection}
                        suppressRowClickSelection={!!rowSelection}
                        onSelectionChanged={onSelectionChanged ? onSelectionChanged : false}
                    />
                    {/* ADD custom pagination */}
                    {onPageChange && (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "10px 8px",
                        fontSize: "14px",
                        gap: "12px",
                    }}>
                        {/* Left — rows per page select */}
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <span style={{ whiteSpace: "nowrap", color: "#555" }}>Per page:</span>
                            <select
                                value={perPage}
                                onChange={(e) => onPerPageChange(Number(e.target.value))}
                                style={{
                                    minHeight: '38px',
                                    outline: '0 !important',
                                    position: 'relative',
                                    transition: 'all 100ms',
                                    backgroundColor: 'hsl(0, 0%, 100%)',
                                    borderColor: 'hsl(0, 0%, 80%)',
                                    borderRadius: '4px',
                                    borderStyle: 'solid',
                                    borderWidth: '1px',
                                    boxSizing: 'border-box',
                                    fontSize: '14px',
                                    padding: '1px 10px'
                                }}
                            >
                                {[10, 25, 50, 100].map(n => (
                                    <option key={n} value={n}>{n}</option>
                                ))}
                            </select>
                        </div>

                        {/* Right — rows info + navigation */}
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <span style={{ whiteSpace: "nowrap", color: "#555", marginRight: "8px" }}>
                                Total rows: {totalRows} 
                            </span>

                            {/* |< First */}
                            <button
                                onClick={() => onPageChange(1)}
                                disabled={currentPage === 1}
                                style={paginationBtnStyle(currentPage === 1)}
                                title="First page"
                            >
                                <img src={`${process.env.PUBLIC_URL}/images/pagination-first.svg`} style={arrowImage()} alt="Pagination First"/>
                            </button>

                            {/* < Prev */}
                            <button
                                onClick={() => onPageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                                style={paginationBtnStyle(currentPage === 1)}
                                title="Previous page"
                            >
                                <img src={`${process.env.PUBLIC_URL}/images/pagination-prev.svg`} style={arrowImage()} alt="Pagination Previous"/>
                            </button>

                            <span style={{ whiteSpace: "nowrap", color: "#333" }}>
                                {currentPage} of {totalPages}
                            </span>

                            {/* > Next */}
                            <button
                                onClick={() => onPageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                                style={paginationBtnStyle(currentPage === totalPages)}
                                title="Next page"
                            >
                                <img src={`${process.env.PUBLIC_URL}/images/pagination-next.svg`} style={arrowImage()} alt="Pagination Next"/>
                            </button>

                            {/* >| Last */}
                            <button
                                onClick={() => onPageChange(totalPages)}
                                disabled={currentPage === totalPages}
                                style={paginationBtnStyle(currentPage === totalPages)}
                                title="Last page"
                            >
                                <img src={`${process.env.PUBLIC_URL}/images/pagination-last.svg`} style={arrowImage()} alt="Pagination Last"/>
                            </button>
                        </div>
                    </div>
                )}
                        {/* <div className='pagination-select'>
                            <CustomSelect data={PAGINATION_PAGE_SIZE_ARR} onChange={onPageSizeChanged} pagination={true}/>
                        </div> */}

                </div>
            </>
        </div>
    );
};

// helper outside component
const paginationBtnStyle = (disabled) => ({
    padding: "4px 5px",
    borderRadius: "6px",
    border: "none",
    background: "#fff",
    color: disabled ? "#bbb" : "#333",
    cursor: disabled ? "default" : "pointer",
    fontSize: "13px",
    fontWeight: "500",
    opacity: disabled ? '0.4' : '1'
});

const arrowImage = () => ({height: '16px', display: 'block'})

export default Table;